var _path, _polyline, _ellipse, _path2, _path3, _polygon, _polygon2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon3, _polygon4, _polygon5, _polygon6, _path12, _rect, _polygon7, _polygon8, _polygon9, _path13, _path14, _rect2, _rect3, _polygon10, _circle, _rect4, _polygon11, _rect5, _polygon12, _path15, _path16, _rect6, _rect7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenmapTwoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#98_open map_twocolour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.45,69c-30.1,19.72-47.93,55.91-45.1,93.7,1.45,19.33,8,38.09,25.77,48.15,47.53,27,254.64,26.77,282.87-20.36,29.08-48.55,19.09-116.14-47-144.54C250.65,21.31,169.17,18.06,91.45,69Z",
    fill: "#e6e6e6",
    opacity: 0.3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "78.6 219.52 78.6 204.67 101.6 204.67 101.6 219.52",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.68,
    cy: 264.1,
    rx: 164.25,
    ry: 15.68,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.87,121.83a6.46,6.46,0,0,0-6.47-6.46,5.89,5.89,0,0,0-1,.09,8.73,8.73,0,0,0-7.68-4.59l-.32,0a10.46,10.46,0,0,0,.32-2.51,10.35,10.35,0,1,0-20.69,0,10.46,10.46,0,0,0,.32,2.51l-.32,0a8.72,8.72,0,1,0,0,17.43H76.25v-.06A6.46,6.46,0,0,0,81.87,121.83Z",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.69,54.73A8.72,8.72,0,0,0,343,46a9.22,9.22,0,0,0-1.4.12,11.75,11.75,0,0,0-10.35-6.19c-.15,0-.29,0-.43,0a14,14,0,1,0-27.05,0c-.14,0-.28,0-.43,0a11.76,11.76,0,0,0,0,23.51h40.8v-.08A8.71,8.71,0,0,0,351.69,54.73Z",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "163.7 121.95 186.17 93.95 191.02 98.2 171.87 130.22 163.7 121.95",
    fill: "#97c680"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.42 85.12 139.56 97.55 129.72 103.81 126.18 82.25 135.42 85.12",
    fill: "#f4a28c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.8,70.23a7.74,7.74,0,0,1,12.81-2.15c4.19,4.47,9.24,11.58,3.53,15.45-8.75,5.93-16.77-5.14-16.77-5.14A14.08,14.08,0,0,1,122.8,70.23Z",
    fill: "#f4a28c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.19,77.86s-2.24-1.88-3.25.78,2.94,4,4.12,2.61S129.19,77.86,129.19,77.86Z",
    fill: "#f4a28c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.23,109.91A25.13,25.13,0,0,1,134,96.13c13.38-4,38,.38,45.51,12.89,10.28,17.13-4.77,71.54-4.77,71.54l-44.94,3.49S105.08,139.45,118.23,109.91Z",
    fill: "#97c680"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.9,95s-21,67.71,39.68,72.2l-2.83,13.4-44.94,3.49s-15.84-24.87-15.17-59.8c0,0,.38-17.27,12.54-24.9A27.37,27.37,0,0,1,137.9,95Z",
    opacity: 0.08
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.23,95.78a22.67,22.67,0,0,0,0,24c4.9,8.27,19.16,24.38,28.91,35a10.3,10.3,0,0,0,16.59-1.94l21-36.92-7.11-4.56-19.2,28.14S183.24,96.32,156.23,95.78Z",
    fill: "#97c680"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.23,95.78a22.67,22.67,0,0,0,0,24c4.9,8.27,19.16,24.38,28.91,35a10.3,10.3,0,0,0,16.59-1.94l21-36.92-7.11-4.56-19.2,28.14S183.24,96.32,156.23,95.78Z",
    fill: "#fff",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M220.2,114.33s11.89-4.37,7-11.09-11.67,8.12-11.67,8.12Z",
    fill: "#f4a28c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.83,86.2l-6.66-6.89a7.25,7.25,0,0,1-2-5.41c.16-3.51.91-9.1,3.81-13.3,4.56-6.58,10.62-9.07,12.13-3.38s1.81-1.07,5.48,2,2.92,4.8,0,6.4-8.95,3.92-9.49,8.73S134.09,83,126.83,86.2Z",
    fill: "#24285b"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "192.65 93.65 203.19 69.44 210.06 78.23 223.41 71.87 229.24 81.72 243.62 79.66 235.08 107.17 221.11 110.77 214.69 100.25 201.31 103.93 192.65 93.65",
    fill: "#ffd200"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "203.86 75.43 196.23 92.39 202.61 100.36 216.37 95.78 221.99 107.91 232.63 104.89 239.51 83.16 227.16 85.28 221.99 75.43 209.49 81.79 203.86 75.43",
    fill: "#fff",
    opacity: 0.2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "210.06 78.23 201.31 103.93 214.69 100.25 223.41 71.87 210.06 78.23",
    opacity: 0.08
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "229.24 81.72 221.11 110.77 235.08 107.17 243.62 79.66 229.24 81.72",
    opacity: 0.08
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187,94.69s1.33-6.06,4-7.62,8.15-.33,5.81,3S191,98.2,191,98.2Z",
    fill: "#f4a28c"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.43,
    y: 213.46,
    width: 70.62,
    height: 52.27,
    fill: "#c9c9c9"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.81 213.46 95.18 265.73 119.68 265.73 127.68 238.5 125.05 213.46 112.81 213.46",
    opacity: 0.08
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.58 180.45 168.6 258.6 159.14 258.6 150.71 197.88 129.81 183.98 174.58 180.45",
    fill: "#24285b"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.81 183.98 116.76 258.6 126.9 258.6 148.79 196.6 129.81 183.98",
    fill: "#24285b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.6,258.6l-6.28,4.63a1.38,1.38,0,0,0,.82,2.49h10.53a1.37,1.37,0,0,0,1.38-1.38V258.6Z",
    fill: "#97c680"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.33,258.6l5.92,4.63a1.39,1.39,0,0,1-.86,2.49h-7.5a4,4,0,0,1-4-4V258.6Z",
    fill: "#97c680"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 291.8,
    y: 108.69,
    width: 5.83,
    height: 153.27,
    fill: "#ffd200"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6,
    y: 221.29,
    width: 7.69,
    height: 7.69,
    fill: "#e6e6e6",
    opacity: 0.49
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "77.25 227.81 83.93 223.44 83.93 231.69 77.25 227.81",
    fill: "#e6e6e6",
    opacity: 0.49
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.18,
    cy: 239.59,
    r: 7.25,
    fill: "#e6e6e6",
    opacity: 0.49
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 268.18,
    y: 131.69,
    width: 34.62,
    height: 12.44,
    transform: "translate(570.98 275.82) rotate(-180)",
    fill: "#24285b"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "268.18 128.18 268.18 147.69 252.43 137.91 268.18 128.18",
    fill: "#24285b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 286.9,
    y: 102.45,
    width: 34.62,
    height: 12.44,
    fill: "#24285b"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.52 98.93 321.52 118.45 337.27 108.67 321.52 98.93",
    fill: "#24285b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M292.18,261.29s9.52-13.69-4.67-17.46,3.42-22.21-9.8-24.63-11,17.08-11,17.08-9.12-7.86-15.41-1.26,2.52,13.85,2.52,13.85-12.71,4.39-4.79,12.42Z",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M273.1,263.11s6-10.34,14.95-9.07,7.95,9.07,7.95,9.07Z",
    fill: "#c9c9c9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 299.55,
    y: 106.67,
    width: 16.63,
    height: 4.11,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 272.8,
    y: 135.88,
    width: 16.63,
    height: 4.11,
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenmapTwoColor);
export default __webpack_public_path__ + "static/media/Open map_Two Color.2495727287b6ffdf02b4a786d0b6af37.svg";
export { ForwardRef as ReactComponent };